<template>
  <div class="flex items-center gap-2" :style="alignStyle">
    <slot name="display">
      <span v-if="col.type !== 'boolean'" :class="col?.noWrap ? 'nowrap-cell' : ''">{{
        cell
      }}</span>

      <!-- In case of boolean type, we display icons -->
      <i v-else :class="cell ? col.iconTrue || 'pi pi-check' : col.iconFalse || 'pi pi-times'" />
    </slot>
    <i
      v-if="showChevron"
      class="mdi cursor-pointer"
      :class="[isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down']"
      @click.stop="toggleTruncation"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { PaginatedDataTableColumnConfig } from '../types/paginatedDataTableTypes';

const props = defineProps<{
  cell: unknown;
  col: PaginatedDataTableColumnConfig;
  rowData: Record<string, unknown>;
  rowIndex: number;
}>();

const emit = defineEmits<{
  (e: 'toggleTruncation', rowIndex: number, field: string): void;
}>();

const { field } = props.col;

//Truncation logic
const originalKey = `original_${field}`;

const showChevron = computed(() => {
  return typeof props.rowData === 'object' && originalKey in props.rowData;
});

const isExpanded = computed(() => {
  if (!showChevron.value || !props.rowData) return false;
  return props.rowData[field] === props.rowData[originalKey];
});

const alignStyle = computed(() => {
  const align = props.col.align || 'left';
  const justifyContentMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  };
  return {
    justifyContent: justifyContentMap[align] || 'flex-start',
  };
});

const toggleTruncation = () => {
  emit('toggleTruncation', props.rowIndex, field);
};
</script>

<style lang="css">
.nowrap-cell {
  white-space: nowrap;
}
</style>
